import React from 'react';
import { FormControlLabel, Switch, SxProps, Tooltip } from '@mui/material';

interface RxBlankoSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  sx?: SxProps;
}

const RxBlankoSwitch: React.FC<RxBlankoSwitchProps> = ({ checked, onChange, sx }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <Tooltip title="Blankoverordnung ausblenden" placement="top">
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={handleChange}
            size="small"
            // sx={{
            //   '& .MuiSwitch-switchBase.Mui-checked': {
            //     color: '#ab003c',
            //   },
            //   '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            //     backgroundColor: '#ab003c',
            //   },
            //   ...sx
            // }}
          />
        }
        label="Rx Blanko"
        sx={{
          margin: 0,
          fontSize: '12px',
          fontFamily: 'Inter',
          '& .MuiFormControlLabel-label': {
            fontSize: '12px',
            fontFamily: 'Inter'
          },
          ...sx
        }}
      />
    </Tooltip>
  );
};

export default RxBlankoSwitch;
